import React from 'react';
export function ProblemSection() {
  return <section className="bg-canvas px-5 py-20 md:py-28" data-id="element-176" data-mp="1dd7w0prpwu9y">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-16" data-id="element-177" data-mp="na7xqjnibx0k">
        <h2 className="text-center text-3xl font-black uppercase leading-tight tracking-tight text-ink md:text-5xl lg:text-left" data-id="element-178" data-mp="8llhmfq2318a">
          ¿Cuántas horas más vas a perder preparando cada charla?
        </h2>
        <p className="border-l-4 border-accent bg-surface px-6 py-6 text-2xl font-black uppercase leading-snug text-ink md:px-8 md:text-3xl" data-id="element-179" data-mp="3voggl00899fj">
          No te falta conocimiento. <span className="block text-accent" data-id="element-180" data-mp="3lrligi7v9b1s">Te falta un sistema.</span>
        </p>
      </div>
    </section>;
}